import { CanDeactivate } from '@angular/router';
import { ComponentDeactivateWarning } from './component-deactive-warning.interface';
import { Injectable } from '@angular/core';
import { NecAlert } from '../../service/alert/alert.service';

@Injectable()
export class NecLeavingWarningGuard implements CanDeactivate<ComponentDeactivateWarning> {
  constructor(
    private alert: NecAlert
  ) { }

  canDeactivate(component: ComponentDeactivateWarning): boolean | Promise<boolean> {
    const deactiveWarning = component.showWarning();
    if (!deactiveWarning.showWarning) {
      return true;
    }
    else {
      return new Promise((resolve, reject) => {
        this.alert.show({
          title: deactiveWarning.warningTitle,
          text: deactiveWarning.warningText,
          accept: () => {
            setTimeout(() => {
              resolve(true);
            }, 200);
          },
          reject: () => {
            resolve(false);
          }
        });
      });
    }
  }
}
